
export default 
  {
    pagoElectronico:{
      total: 233000,
      tdd:122100,
      tdc:110900
    },
    efectivo:{
      dolar:315000,
      bs:0,
      total: 315000
    },
    otros:{
      zelle:0,
      wallet:0,
      paypal:0,
      total:0
    },
    totalGeneral:1000000,
    turno:"",
    tienda:"",
    area:"",
    caja:"",
    fecha:"",
    faltante:"",
    sobrante:"",
    factInicial:"",
    factFinal:""
   }          
  
  